// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "LaunchButton-module--bx--text-truncate--end--Ts6+w";
export var bxTextTruncateFront = "LaunchButton-module--bx--text-truncate--front--klqMU";
export var button = "LaunchButton-module--button--xmnfL";